
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recept/[id]",
      function () {
        return require("private-next-pages/recept/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recept/[id]"])
      });
    }
  